import React, { useEffect } from 'react';
import Template from '../../../components/organisms/Template';
import { Container, Button } from 'react-bootstrap';
import ReceiptView from '../../../components/organisms/ReceiptView';
import html2pdf from 'html2pdf.js';

function ReceiptExport(props) {

  const backpage = async () => {
    props.history.push(`/receipt/generate/${encodeURI(JSON.stringify(inputs))}`);
  };

  const exportFile = async () => {
    const element = document.getElementById('divToPrint');
    const elementsToHide = document.getElementsByClassName('html2pdf__ignore');
    elementsToHide.forEach((elementToHide) => {
      elementToHide.style.display = 'none';
    });
    await html2pdf(element, { filename: 'recibo-'+Date.now()+'.pdf' });
    elementsToHide.forEach((elementToHide) => {
      elementToHide.style.display = 'block';
    });
  };

  const getInputsFromURL = (pathname) => {
    if (pathname) {
      return pathname.substring(pathname.lastIndexOf('receipt/export/') + 15);
    }

    return '';
  };

  const encodedInputs = getInputsFromURL(props.history.location.pathname);
  const inputs = JSON.parse(encodedInputs);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [inputs]);

  return (
    <Template>
      <Container>
        <Button className="float-left" onClick={() => exportFile()}>Salvar recibo</Button>
        <Button className="float-right" variant="secondary" onClick={() => backpage()}>Voltar</Button>
        <ReceiptView inputs={inputs} />
      </Container>
    </Template>
  );
}

export default ReceiptExport;